import React, { useRef, useState, useEffect } from "react";

import { useNavigate, useParams } from "react-router-dom";
import { Form, Input, Select, Button, Space, Spin } from "antd";

import Sidebar from "../../../components/AdminComponents/SideNav";
import { SettingsMenu } from "../../../components/AdminComponents/MenuItems";
import Axios from "../../../api/Axios";
import { message } from "antd";
import {
  TrademarkOutlined,
  BackwardOutlined,
  FormOutlined,
} from "@ant-design/icons";
import SecondaryNav from "../../../components/AdminComponents/SecondaryNav2";
import { capitalizeWords } from "../../../components/icons/ApplicationColor";
const { Option } = Select;

const ModuleRolesEdit = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const formRef = useRef();
  const handleReset = () => {
    formRef.current.resetFields();
  };
  const [displayApps, setDisplayApps] = useState([]);
  const displayApplications = async () => {
    try {
      const res = await Axios.get(`/globaluserappaccess/`, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      setDisplayApps(res.data);
    } catch (err) {
      //console.log(err);
    }
  };
  useEffect(() => {
    displayApplications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  //console.log(csrfToken);
  const onFinish = async (values) => {
    //console.log(values);
    try {
      await Axios.put(`/role/${parseInt(id)}/`, values, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      CreateSuccessfull();
    } catch (err) {
      //console.log(err);
      CreateFailed();
    }
  };
  const CreateSuccessfull = () => {
    messageApi.open({
      type: "success",
      content: "New Role has been edited.",
      duration: 5,
    });
    setTimeout(() => {
      history(`/access-manager/roles`);
    }, 2000);
  };

  const CreateFailed = () => {
    messageApi.open({
      type: "error",
      content: "Role has been not been edited.",
      duration: 5,
    });
  };
  const history = useNavigate();
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const LoadUser = async () => {
    try {
      const res = await Axios.get(`/role/${id}/`);
      setData(res.data);
      //console.log(res.data);
      setLoading(false);
      //console.log(data);
    } catch (err) {
      //console.log(err);
    }
  };
  useEffect(() => {
    LoadUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (!loading && formRef.current) {
      formRef.current.setFieldsValue({
        role_id: data?.role_id,
        name: data.name,
        user_group: data.user_group,
        scope: data.scope,
        applications: data.applications.map((app) => app.id), /// how set here
      });
    }
  }, [loading, data]);
  const thirdMenuData = [
    {
      path: `/access-manager/roles/edit-role/${id}`,
      name: "Edit Roles",
      icon: (
        <TrademarkOutlined
          style={{ fontSize: "15.5px", marginRight: "5px", margintop: "1px" }}
        />
      ),
    },
  ];
  return (
    <div className="page-scroller">
      <Sidebar props={SettingsMenu}>
        {contextHolder}
        <SecondaryNav menuItems={thirdMenuData} />
        <Spin spinning={loading}>
          <div className="form-container">
            <Form
              name="complex-form"
              onFinish={onFinish}
              layout="vertical"
              ref={formRef}
              labelCol={{
                span: 14,
              }}
              wrapperCol={{
                span: 16,
              }}
              style={{
                Width: "100%",
              }}
            >
              <div className="group1">
                <div className="form-heading">
                  {capitalizeWords("EDIT ROLE")}
                </div>
                <div className="group-1-box">
                  <div style={{ display: "inline-block" }}>
                    <Form.Item
                      label={<p className="my-form-lables">Role ID</p>}
                    >
                      <Space>
                        <Form.Item
                          name="role_id"
                          noStyle
                          rules={[
                            { required: true, message: "ID is required" },
                            {
                              pattern: /^[a-zA-Z0-9]*$/,
                              message:
                                "Please enter alphanumeric characters only",
                            },
                          ]}
                        >
                          <Input
                            className="my-form-input"
                            placeholder={
                              //   errors.username
                              //     ? `${errors.username}`
                              //     :
                              "Enter role ID"
                            }
                          />
                        </Form.Item>
                      </Space>
                    </Form.Item>
                  </div>
                  <div style={{ display: "inline-block", marginLeft: "2rem" }}>
                    <Form.Item
                      label={<p className="my-form-lables">Role Name</p>}
                    >
                      <Space>
                        <Form.Item
                          name="name"
                          noStyle
                          rules={[
                            { required: true, message: "name is required" },
                          ]}
                        >
                          <Input
                            className="my-form-input"
                            placeholder="Enter role name"
                          />
                        </Form.Item>
                      </Space>
                    </Form.Item>
                  </div>
                </div>
                <div className="group-1-box" style={{ paddingTop: "1rem" }}>
                  <div style={{ display: "inline-block" }}>
                    <Form.Item
                      label={<p className="my-form-lables">User Group</p>}
                    >
                      <Input.Group compact>
                        <Form.Item
                          name="user_group"
                          noStyle
                          initialValue={"TRAINERY"}
                        >
                          <Select
                            placeholder="Select Group"
                            className="my-form-input"
                          >
                            <Option value="TRAINERY">TRAINERY</Option>
                            <Option value="CLIENT">CLIENT</Option>
                          </Select>
                        </Form.Item>
                      </Input.Group>
                    </Form.Item>
                  </div>

                  <div style={{ display: "inline-block", marginLeft: "2rem" }}>
                    <Form.Item label={<p className="my-form-lables">Scope</p>}>
                      <Input.Group compact>
                        <Form.Item name="scope" noStyle initialValue={"GLOBAL"}>
                          <Select
                            placeholder="Select scope"
                            className="my-form-input"
                          >
                            <Option value={"GLOBAL"}>GLOBAL</Option>
                            <Option value={"APP"}>APP</Option>
                          </Select>
                        </Form.Item>
                      </Input.Group>
                    </Form.Item>
                  </div>
                </div>
                <div className="group-1-box" style={{ paddingTop: "1rem" }}>
                  <div style={{ display: "inline-block" }}>
                    <Form.Item
                      label={<p className="my-form-lables">Applications</p>}
                    >
                      <Input.Group>
                        <Form.Item
                          name="applications"
                          noStyle
                          rules={[
                            {
                              required: true,
                              message: "application is required",
                            },
                          ]}
                        >
                          <Select
                            key="applications"
                            placeholder="Select Application"
                            className="my-form-input"
                            style={{ width: "50rem" }}
                            mode="multiple"
                          >
                            {displayApps?.map((app) => (
                              <Option key={app.id} value={app.id}>
                                {app.name}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Input.Group>
                    </Form.Item>
                  </div>
                </div>
              </div>

              <div
                style={{
                  display: "inline-block",
                  marginLeft: "5rem",
                  paddingTop: "3rem",
                }}
              >
                <Form.Item label=" " colon={false}>
                  <Button
                    type="text"
                    htmlType="button"
                    style={{
                      background: "#D3D3D3",
                    }}
                    onClick={() => {
                      history(`/access-manager/roles`);
                    }}
                  >
                    <BackwardOutlined />
                    Back
                  </Button>
                </Form.Item>
              </div>

              <div style={{ display: "inline-block", marginLeft: "16px" }}>
                <Form.Item label=" " colon={false}>
                  <Button
                    type="primary"
                    htmlType="button"
                    onClick={handleReset}
                  >
                    Reset
                  </Button>
                </Form.Item>
              </div>
              <div style={{ display: "inline-block", marginLeft: "16px" }}>
                <Form.Item label=" " colon={false}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    // className="my-form-input-end"
                    style={{
                      background: "#f58029",
                      fontWeight: "600",
                    }}
                    className="save-update-btn"
                  >
                    Update
                    <FormOutlined />
                  </Button>
                </Form.Item>
              </div>
            </Form>
          </div>
        </Spin>
      </Sidebar>
    </div>
  );
};

export default ModuleRolesEdit;
